var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Principal'),_c('InfoHome'),_c('Features'),_c('PhoneHome'),_c('Empresas'),_vm._m(0),_c('FooterHome')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff","padding":"6% 0%"}},[_c('img',{staticClass:"chips-image",staticStyle:{"width":"100%"},attrs:{"src":require("../../public/assets/img/grupos.svg"),"alt":"chips grupos"}})])
}]

export { render, staticRenderFns }